const i18nService = {
  defaultLanguage: "ua",

  languages: [
    {
      lang: "ua",
      name: "Українська",
      flag: process.env.BASE_URL + "media/svg/flags/145-ukraine.svg",
    },
    {
      lang: "pl",
      name: "Polski",
      flag: process.env.BASE_URL + "media/svg/flags/211-poland.svg",
    },
    {
      lang: "en",
      name: "English",
      flag: process.env.BASE_URL + "media/svg/flags/012-uk.svg",
    },
  ],

  /**
   * Keep the active language in the localStorage
   * @param lang
   */
  setActiveLanguage(lang) {
    localStorage.setItem("language", lang);
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  getActiveLanguage() {
    return localStorage.getItem("language") || this.defaultLanguage;
  },
};

export default i18nService;
